import { Header } from './Header';
import { Footer } from './Footer';
import { Toaster } from './ui/sonner';
import { GDPRBanner } from './GDPRBanner';

export const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <Toaster />
      <GDPRBanner />
    </div>
  );
};
